export const SOLANA_DEVNET_RPC_URL = "https://idelle-8nxsep-fast-devnet.helius-rpc.com";
export const SOLANA_MAINNET_RPC_URL = "https://celestia-cegncv-fast-mainnet.helius-rpc.com";
const SUPPORTED_SOLANA_NETWORKS = new Set([
    "solana_devnet",
    "solana_mainnet",
]);
export function normalizeSolanaRpcUrl(rpcUrl) {
    if (typeof rpcUrl !== "string")
        return null;
    const trimmed = rpcUrl.trim();
    return trimmed.length > 0 ? trimmed : null;
}
export function isSupportedSolanaRpcNetwork(network) {
    return typeof network === "string" && SUPPORTED_SOLANA_NETWORKS.has(network);
}
export function resolveSolanaWalletStandardChain(network, context) {
    switch (network) {
        case "solana_devnet":
            return "solana:devnet";
        case "solana_mainnet":
            return "solana:mainnet";
        case undefined:
        case null:
        case "":
            throw new Error(`${context} requires an explicit Solana network. ` +
                `Provide one of: solana_devnet, solana_mainnet.`);
        default:
            throw new Error(`${context} does not support Solana network "${network}". ` +
                `Expected one of: solana_devnet, solana_mainnet.`);
    }
}
export function resolveSolanaRpcUrl(explicitRpcUrl, network, context) {
    if (network != null && network !== "" && !isSupportedSolanaRpcNetwork(network)) {
        throw new Error(`${context} does not support Solana network "${network}". ` +
            `Expected one of: solana_devnet, solana_mainnet.`);
    }
    const rpcUrl = normalizeSolanaRpcUrl(explicitRpcUrl);
    if (rpcUrl)
        return rpcUrl;
    throw new Error(`${context} requires an explicit Solana RPC URL. Pass config.rpcUrl before signing or submitting onchain transactions.`);
}
